import React from 'react';
import { motion } from "framer-motion";
import { blackblue, cementgray } from "./data";
import { ThemeContext } from '..';

export const ProjectList = ({ fetching, repoDetails }) => {
    const darkMode = React.useContext(ThemeContext);

    const noData = () => {
        return (
            <div className="text-center" style={{ width: "100%" }}>
                <h5 className="title">Don't have Any open source projects</h5>
                <img src="/img/nodata.svg" width="50%" height="auto" />
            </div>
        )
    }

    const loading = () => {
        return (
            <h4 className="text-center title" style={{ width: "100%" }}>Loading....</h4>
        )
    }

    return (
        <section className="section is-small has-text-centered is-long" id="project" style={{ background: darkMode ? cementgray : blackblue }}>

            <center className="skils-section title" style={{ color: "white", margin: "25px" }}>{"Github Projects".toUpperCase()}</center>
            <div className="columns is-multiline level" style={{ height: "510px", overflowX: "hidden" }}>

                {!fetching ? repoDetails ? (
                    repoDetails.map(i => {
                        return (
                            <div className="column is-12-mobile is-half-tablet is-one-third-desktop level-item" key={i.id}>
                                <motion.div
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                >

                                    <div className={`box ${darkMode ? "project-card-night" : "project-card"}`} style={{ height: "150px" }}>
                                        <div className="project-title" >{i.name}</div>
                                        <p className="project-desc">{i.description ? `${i.description.slice(0, 60)}...` : "Don't have description"}</p>
                                        <div>
                                            <button className="button-outline" style={{ padding: "6px 20px", color: "white" }}><a href={i.svn_url} style={{ color: darkMode ? "white" : "black" }}>Go to Project</a></button>
                                        </div>
                                    </div>
                                </motion.div>
                            </div>
                        );
                    })
                ) : noData()

                    : loading()}

            </div>


        </section >
    );
}